import systemConfig from '../../../config/systematic';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import dayjs from 'dayjs';
import { handleData } from '../warehouse/EntrepotReport/DailyReport';
import antMessage from '../../../utils/extend/AntdNotification'
import DownloadExcel from '../../report/DownloadExcel';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

const { RangePicker } = DatePicker;

export default function PurContrast() {
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm();

  const [user, setUser] = useState<any>("")
  const [deptData, setDeptData] = useState<any>();
  const [buyerData, setBuyerData] = useState<any>();

  const [queryCriteria, setQueryCriteria] = useState<any>("")

  const [rows, setRows] = useState<any>([]);

  const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false)

  const notificationApi = useNotificationInstance()

  useEffect(() => {
    const fetchData = async () => {
      form.setFieldValue("nowChooseTime", [dayjs(), dayjs()])
      form.setFieldValue("lastChooseTime", [dayjs(), dayjs()])
      let deptData = await fetchApi.GET(wmService, {
        apiId: "dept",
        apiExtend: 'showList',
        apiData: {

        }
      })
      if (deptData.success) {
        setDeptData(deptData.data)
      }

      let buyerData = await fetchApi.GET(wmService, {
        apiId: "buyer",
        apiExtend: 'showList'
      })
      if (buyerData.success) {

        setBuyerData(buyerData.data)
      }
      let classificationWarehouseData = await fetchApi.GET(wmService, {
        apiId: "classificationWarehouse",
        apiExtend: 'showList'
      })

      if (classificationWarehouseData.success) {
        setClassificationWarehouseData(classificationWarehouseData.data)
      }

      // 
    }
    fetchData()
  }, [])
  /** 表头内容 */
  let columnsHead: any = [
    // {
    //   title: "采购商",
    //   dataIndex: "buyerName",
    // },
    {
      title: "品号",
      dataIndex: "selfId",
    },



    {
      title: "品名",
      dataIndex: "productName",
    },
    {
      title: "单位",
      dataIndex: "productUnitName",
    },
    {
      title: "上次数量",
      dataIndex: "lastBNum",
      render: (text: any) => (text ? text.toFixed(2) : 0)
    },
    {
      title: "上次均价",
      dataIndex: "lastUnivalence",
      render: (text: any) => (text ? text.toFixed(2) : 0)

    },

    {
      title: "上次金额",
      dataIndex: "lastAmount",
      render: (text: any) => (text ? text.toFixed(2) : 0)

    },

    {
      title: "本次数量",
      dataIndex: "nowBNum",
      render: (text: any) => (text ? text.toFixed(2) : 0)

    },
    {
      title: "本次均价",
      dataIndex: "nowUnivalence",
      render: (text: any) => (text ? text.toFixed(2) : 0)

    },

    {
      title: "本次金额",
      dataIndex: "nowAmount",
      render: (text: any) => (text ? text.toFixed(2) : 0)
    },
    {
      title: "数量差异",
      dataIndex: "bNumDifference",
    },

    {
      title: "单价差异",
      dataIndex: "univalenceDifference",
    },
    {
      title: "金额差异",
      dataIndex: "amountDifference",
    },






  ]
  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {
        fetchApi.GET(wmService, {
          apiId: "costReport",
          apiExtend: 'purContrast',
          apiData: {
            deptIds: handleData(values.deptIds, "deptId"),
            lastTime: values.lastChooseTime ? {
              startTime: dayjs(values.lastChooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.lastChooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            nowTime: values.nowChooseTime ? {
              startTime: dayjs(values.nowChooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.nowChooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            buyers: handleData(values.buyers, "buyerId"),
            classificationWarehouses: handleData(values.classificationWarehouses, "classificationWarehouseId"),

            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,

          }
        }).then((res: any) => {
    setIsLoading(false)
          setRows(res.data.rows)
          setQueryCriteria(res.data.queryCriteria)
          setUser(res.data.user)
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });;

        }).catch((err: any) => {
           setIsLoading(false)
          console.log("err", err);
          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
        })
      })
      .catch((err) => {
         setIsLoading(false)
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;
      })





  }
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
      >
        <Row>
          <Col span={8}>
            <Form.Item
              label="部门"
              name="deptIds"
            >
              <Select
                // orderTypeData
                mode="multiple"
                showSearch
                placeholder="请选择部门!"
                optionFilterProp="children"

                onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(deptData, 'deptName')}
              </Select>
            </Form.Item>
          </Col>


          <Col span={6}>
            <Form.Item
              label="采购商"
              name="buyers"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="采购商"
                optionFilterProp="children"
                // onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(buyerData, 'buyerName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              label="品号"
              name="selfStart"
            >
              <Input
              // onChange={handleChange}
              // onBlur={handleBlur}
              // placeholder="Input a number"
              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              colon={false}
              label="-"
              name="selfEnd"
            >
              <Input
              // onChange={handleChange}
              // onBlur={handleBlur}
              // placeholder="Input a number"
              />
            </Form.Item>
          </Col>


          <Col span={6}>
            <Form.Item
              label="分类"
              name="classificationWarehouses"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="分类"
                optionFilterProp="children"
                onSearch={(e) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="上次日期"
              name="lastChooseTime"
            >
              <RangePicker
                defaultValue={[dayjs(), dayjs()]}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="本次日期"
              name="nowChooseTime"
            >
              <RangePicker
                defaultValue={[dayjs(), dayjs()]}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item >
              <Space>
               <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                <Button onClick={() => DownloadExcel(rows, "costPurContrast", queryCriteria)}>下载EXCEL文件</Button>

                {/* purContrast */}
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div style={{ marginTop: "20px" }}>
        <Table
          scroll={{ x: "100%", y: 650 }}
          pagination={false}
          rowKey={(record: any, index: any) => {
            return index
          }}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>

      </div>
    </>
  )
}
